import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { compatApi } from '../../utils/Intercepter';

function ProjectAssignmentList() {
  const storedUser = sessionStorage.getItem('user');
  const user = storedUser && JSON.parse(storedUser);
  const organizationCode = user?.organizationCode || '';

  const [projectList, setProjectList] = useState([]);

  useEffect(() => {
    const fetchProjectList = async () => {
      try {
        const response = await compatApi.post('/project/readProjectList', organizationCode);
        const data = await response.json();
        // TODO: 백엔드 수정 필요
        setProjectList(data.map(project => ({ ...project, assignedPersonnelCount: 0 })));
      } catch (error) {
        console.log(error);
        alert('프로젝트 목록을 불러오는 데 실패했습니다.');
      }
    };
    fetchProjectList();
  }, [organizationCode, user?.jwt]);

  const getProjectStatus = (startDate, endDate) => {
    const now = new Date();
    const start = new Date(startDate);
    const end = new Date(endDate);

    if (now < start) {
      return '예정';
    } else if (now > end) {
      return '종료';
    } else {
      return '진행중';
    }
  };

  return (
    <div style={{ padding: '20px', backgroundColor: '#f0f8ff' }}>
      <div className="mb-4 shadow-sm card">
      <h5 className="card-header-custom d-flex justify-content-between align-items-center card-header">
        <span>인력투입 정보 (프로젝트 목록)</span>
      </h5>
      <div className="card-body">
        <div className="table-responsive">
          <table className="text-center align-middle table table-striped table-bordered table-hover">
            <thead className="table-dark-custom">
              <tr>
                <th>프로젝트명</th>
                <th>시작일</th>
                <th>종료일</th>
                <th>상태</th>
                <th>투입 인원수</th>
                <th>관리</th>
              </tr>
            </thead>
            <tbody>
              {projectList.map((project) => (
                <tr key={project.projectId}>
                  <td>{project.projectName}</td>
                  <td>{format(new Date(project.startDate), 'yyyy-MM-dd')}</td>
                  <td>{format(new Date(project.endDate), 'yyyy-MM-dd')}</td>
                  <td>{getProjectStatus(project.startDate, project.endDate)}</td>
                  <td>{project.assignedPersonnelCount}명</td>
                  <td>
                    <Link to={`/project-assignments/${project.projectId}`} state={project} className="btn btn-outline-primary btn-sm">
                      상세 보기
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </div>
  );
}

export default ProjectAssignmentList;